import type {
  FeatureApiResponse,
  TariffFeaturesApiResponse,
} from '@/features/Features';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class FeaturesHttpService extends HttpService {
  loadFeatures(): HttpClientResponse<FeatureApiResponse> {
    return this.httpClient.get('merkmale');
  }

  loadTariffFeatures(
    tariffId: string,
    berechnungsId: string,
    isAllTimeTariff = false,
  ): HttpClientResponse<TariffFeaturesApiResponse> {
    return this.httpClient.get(`tarif/${tariffId}/merkmale`, {
      params: {
        berechnungsId,
        isAllTimeTariff,
      },
    });
  }
}
